function calculateMiles(price, quantity = 1) {
  if (
    price < 0 ||
    Number.isNaN(price) ||
    quantity < 0 ||
    Number.isNaN(quantity)
  )
    throw new Error("Invalid data to calculate miles")

  const milesDict = { US: 6, CA: 4, AU: 4, NZ: 4, UK: 6, EU: 6 }
  const region = window.Shopify.country.toString().toUpperCase() || "US"
  const milesMultiplier = milesDict[region] || 6
  const priceValue = (price * quantity) / 100
  const mileage = Math.round(priceValue * milesMultiplier)
  return mileage
}
